/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { DownloadReleasePage } from '@/pages/DownloadRelease/DownloadReleasePage';

export function DownloadReleaseRoute() {
  return <DownloadReleasePage />;
}
